//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TeacherDialog from '../_components/TeacherDialog';
import Searchbar from './_components/Searchbar';
import { cleanObj } from '~/utils';

export default {
  name: 'TeacherList',
  components: { TeacherDialog, Searchbar },
  data() {
    return {
      teacherList: [],
      isTeacherDialogShow: false,
      currentId: 0,
    };
  },
  head() {
    return {
      title: 'STEP1NE 培訓講師團隊 - 專業培訓與指導',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: '遇見STEP1NE的專業講師 - 培訓和技能提升',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '探索STEP1NE的專業培訓講師團隊。我們的講師擁有豐富經驗和專業知識，致力於提供高質量的職業培訓和技能提升課程。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '探索STEP1NE的專業培訓講師團隊。我們的講師擁有豐富經驗和專業知識，致力於提供高質量的職業培訓和技能提升課程。',
        },
      ],
    };
  },
  computed: {
    nodata() {
      return !this.teacherList || this.teacherList.length < 1;
    },
  },
  methods: {
    getLecturerList(payload = {}) {
      this.$api('getLecturerList', cleanObj(payload, true)).then(data => {
        this.teacherList = data.records;
      });
    },
    openTeacherCard(id) {
      this.currentId = id;
      this.isTeacherDialogShow = true;
    },
    onSearch(payload) {
      this.getLecturerList(payload);
    },
  },
  mounted() {
    this.getLecturerList();
  },
};
